import { render, staticRenderFns } from "./ModalModelCompetition.vue?vue&type=template&id=8ec25e5c"
import script from "./ModalModelCompetition.vue?vue&type=script&lang=js"
export * from "./ModalModelCompetition.vue?vue&type=script&lang=js"
import style0 from "./ModalModelCompetition.vue?vue&type=style&index=0&id=8ec25e5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports